import React, {useEffect, useRef, useState} from 'react';
import * as Icon from 'ubs-icons';
import {COLOR, PROFILE_SECTION} from "ubs-framework/v2/common/constant";
import {useFieldLabel} from "ubs-framework/v2/hooks/useCustomFieldConfig";
import UButton from "ubs-framework/v2/UButton";
import UCustomScrollBar from 'ubs-framework/v2/UCustomScrollBar';
import UNoDataFound from 'ubs-framework/v2/UErrorPages/UNoDataFound';
import useUAlert from "ubs-framework/v2/UAlert";
import useSocket from "../../common/hooks/useSocket";
import {useSelector} from "react-redux";
import {onLogout, sendData} from "../../../store/actions";
import {bytesToSize, getExtension} from "ubs-framework/v2/common/function";
import UDatePicker from "ubs-framework/v2/UDatePicker";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import CongratulationsModal from "../interview-questions/congratulations-modal";
import {showMoreText} from "ubs-framework/v2/ShowMoreText";
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UInput from "ubs-framework/v2/UInput";
import EmployeeSignature from "../../../common/components/employee-signature";
import {downloadBase64ToPDF} from "../../preboarding/components/common/functions";
import {DOC_SIGNATURE_STATUS, PRE_BOARDING_TEMPLATE_TYPE, STATUS_CONST} from "../../../common/constant";
import Validator from "simple-react-validator";
import {checkCookie} from "ubs-framework/v2/common/function";


const OfferAcceptDecline = () => {
    const alert = useUAlert();
    const getLabel = useFieldLabel();
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}}));
    const _ORG_ID = useSelector(e => e.common.orgId);
    const _USER = useSelector(e => e.common._user);
    const _PID = useSelector(e => e.common.preBoardingId);
    const _PST = useSelector(e => e.common.preBoardingStatus);
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL);
    const [allData, setAllData] = useState({
        preBoardingId: "",
        recruiterName: "",
        recruiterPhone: "",
        selected: null,
        showReason: false,
        reason: "",
        status: 1, // 2 accept , 1-reject
        isSignature: false, // this will true if any document have signature placeholder in it.
        disableAccept: false, // this will true when signture is on documernt and its is pending,
        disableAcceptReject: false, // this will,
        joiningDate: null, // collect joining Date only  when candidate is accepting the offer else dont send to backend
    });

    const [allDoc, setAllDoc] = useState([
        // {
        //     proofId:""
        //     name:"",
        //     file:""
        // }
    ]);
    const [loading, setLoading] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);


    useEffect(() => {
        sendData('ats|documents|fetch', {user: _USER?.value, preBoardingId: _PID})
        if (_PST === STATUS_CONST.OFFER_ACCEPTED || _PST === STATUS_CONST.OFFER_DECLINED || _PST === STATUS_CONST.READY_TO_ONBOARDING) {
            setShowThankYou(true);
            setAllData(_ => ({..._, disableAcceptReject: true}));
        }else if(_PST === STATUS_CONST.READY_TO_ONBOARDING) {
            setAllData(_ => ({..._, disableAcceptReject: true}));
        }
    }, []);

    useEffect(() => {
        on()
        return () => off()
    }, [_PID,_USER]);



    const {on, off} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|documents|fetch':
                    let isSignature = res?.data?.result?.find(_ => (_?.isSignature && _?.templateType === 1));
                    setAllDoc(res?.data?.result);
                    setAllData(_ => (
                        {
                            ..._,
                            isSignature: !!isSignature,
                            ...((res?.data?.result?.length > 0) && {
                                selected: res?.data?.result[0],
                            }),
                            ...(res?.data?.candidateInfo?.joiningDate && {joiningDate: new Date(res?.data?.candidateInfo?.joiningDate)?.getTime()})
                        }));
                    break;
                case 'ats|pre|boarding|offerActionTaken':
                    setAllData(_ => ({..._, showReason: false, reason: "", status: 1, disableAcceptReject: true, joiningDate: null}));
                    setShowThankYou(true)
                    setLoading(false);

                    break
                case 'ats|documents|download':
                    downloadBase64ToPDF(res?.data?.result)
                    setLoading(false);
                    break
                case 'ats|pre|boarding|candidate|document|fetch':
                    setAllData(_ => ({..._, documentName: res?.data?.result?.documentName, documentId: res?.data?.result?._id}));
                    break;
                default:
                    return true;
            }
        } else {
            switch (res.code) {

            }
        }
    });


    const handle = {
        reasonModal: (e, name) => {
            if (e === "accept" || e === "reject") {
                setAllData(_ => ({..._, showReason: true, status: e === 'accept' ? 2 : 1}))
            } else {
                setAllData(_ => ({..._, [name]: e?.target.value}));
            }
        },
        changeDate: (e, name)=>{
            setAllData(_ => ({..._, [name]: new Date(e)?.getTime()}));
        },
        closeReasonModal: () => {
            setAllData(_ => ({..._, showReason: false, reason: "", status: 1,}));
        },
        reasonSubmit: (status) => {
            alert.show({
                title: `Offer ${status === 11 ? "Accept" : "Decline"} `,
                description: `Are you sure want to ${status === 11 ? "accept" : "decline"} offer ?`,
                icon: <Icon.Warning fill={COLOR.u_red} size={30}/>,
                onSubmit: () => {
                    if(validator?.current?.allValid()){
                        sendData('ats|pre|boarding|offerActionTaken', {
                            _id: _PID,
                            user: _USER?._id,
                            status,
                            reason: allData?.reason || "",
                            ...(status === 11 && {joiningDate: allData?.joiningDate })
                        });
                        handle?.closeReasonModal();
                        setLoading(true);
                    }else{
                        validator?.current?.showMessages()
                    }
                }
            })
        },
        viewDocument: (e, item) => {
            // e?.preventDefault();
            setAllData(_ => ({..._, selected: item}));
        },
        downloadHandle: (e, item) => {
            sendData("ats|documents|download", {_id: item?._id, user: _USER?._id, isSignature: true});
            setLoading(true);
        },
        logOut: () => {
            alert.show({
                title: `Want to Logout?`,
                description: `Are you sure you want to logout?`,
                icon: <Icon.Delete fill={COLOR.u_red} size={30}/>,
                onSubmit: () => {
                    onLogout(true, _ORG_ID)
                }
            })

        },
        closeThankYou: () => {
            setShowThankYou(false)
            setAllData(_ => ({..._, disableAcceptReject: true}));
        }
    }

    return (
        <React.Fragment>
            <div className={"u_h-full"}>
                <UCustomScrollBar className={''}>
                    <div className="u_portalSign-body u_bg-white u_flex u_h-full u_p-10">

                        <div className="u_portalSign-notes u_p-0" style={{height: "calc(100% - 70px)"}}>
                            <div className="u_w-100 u_flex u_align-center u_content-end u_p-14 u_border-bottom ">
                                <UButton variant="greenLower" loading={loading} disabled={allData?.disableAccept || allData?.disableAcceptReject}
                                         title="Accept"
                                         type='Accept' cn="u_emp-signature-submitBtn u_portalSign-notes-btn"
                                         onClick={() => {
                                             handle?.reasonModal("accept")
                                         }}/>
                                <UButton variant="redLower" loading={loading} disabled={allData?.disableAcceptReject} title="Decline"
                                         type='Decline'
                                         cn="u_emp-signature-submitBtn u_portalSign-notes-btn u_ml-10 u_w-100"
                                         onClick={() => {
                                             handle?.reasonModal("reject")
                                         }}/>
                                <UButton variant="white" type="Logout"
                                         cn="u_next-btn u_ml-10 u_portalSign-notes-btn u_emp-signature-submitBtn"
                                         onClick={() => {
                                             handle?.logOut()
                                         }}/>
                            </div>
                            <div className="u_h-full u_p-15">
                                {/*<UCustomScrollBar className={''}>*/}
                                {!!allDoc?.length && allDoc?.map((item, i) => {
                                    (item && item?.file?.fileName) ? item.file.ext = getExtension((item?.file?.fileName)) : null;
                                    return (
                                        <div className="u_w-full u_border-radius-5 u_mb-10 u_border u_cp"
                                             style={{border: `1px solid ${[allData?.selected?._id]?.includes(item?._id) ? COLOR?.u_blue : COLOR?.u_gray} `}}
                                             onClick={(e) => {
                                                 handle?.viewDocument(e, item)
                                             }}>

                                            <div className={`u_file-info`} style={{minHeight: `90`}}>
                                                <div className="u_file-info-icon">
                                                    <span className="u_m-auto u_text-center">
                                                        {item?.file?.ext === "pdf" ?
                                                            <Icon.PDF fill={COLOR.u_pastelred} size={18}/>
                                                            : <Icon.FilePreview fill={COLOR.u_blue} size={18}/>
                                                        }
                                                        <span className="u_font">{item?.file?.ext ?? '-'}</span>
                                                    </span>
                                                </div>
                                                <div className="u_file-info-content">
                                                    <p className="u_file-name u_one-line u_mb-5">
                                                        {item?.file?.fileName ?
                                                            showMoreText(item?.file?.fileName)
                                                            : (item?._id === allData?.documentId && allData?.documentName)
                                                                ? allData?.documentName
                                                                : '-'}
                                                    </p>
                                                    <div className="u_flex u_align-center"><p
                                                        className="u_small-font u_mr-10">{item?.file?.size ? bytesToSize(item?.file?.size) : ""}</p>
                                                    </div>
                                                </div>

                                                <div className={"u_cp"}>
                                                    {
                                                        (item?.isSignature && [DOC_SIGNATURE_STATUS.AWAITING_SIGNATURE]?.includes(item?.signatureStatus) && item?.templateType === PRE_BOARDING_TEMPLATE_TYPE.DYNAMIC) ?
                                                            <span onClick={(e) => handle?.downloadHandle(e, item)}><Icon.Download size={16} fill={COLOR.u_icon_bg}/></span>
                                                            : item?.file?.url ?
                                                            <a href={`${_S3_BASE_URL}${item?.file?.url}`} target="_blank" download><Icon.Download size={16} fill={COLOR.u_icon_bg}/></a> : ""
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    )
                                })}

                                {/*</UCustomScrollBar>*/}
                            </div>
                        </div>

                        <div className="u_portalSign-documents  u_border-right u_p-0 u_h-full u_w-full">
                            {(allData?.selected?.file?.url && !allData?.selected?.isSignature) ?
                                <div className={'u_portalSign-documents-container u_row u_p-15 u_h-full u_flex u_content-center u_align-center'}>
                                    {["png", "jpg", "jpeg"]?.includes(allData?.selected?.file?.ext) ?
                                        <div className={""}>
                                            <img src={`${_S3_BASE_URL}${allData?.selected?.file?.url}`} alt=""  style={{maxWidth: "800px", width:"100%", margin: "auto"}}/>
                                        </div>
                                        : <React.Fragment>
                                            <iframe
                                                src={_S3_BASE_URL + allData?.selected?.file?.url + '#toolbar=0&navpanes=0&embedded=true'}
                                                type="application/pdf" width="100%"
                                                height="100%"
                                                name={"offerPreview"}
                                            />
                                        </React.Fragment>
                                    }
                                </div>
                                :
                                <div className={'u_portalSign-documents-container u_row  u_h-full'}>
                                    <EmployeeSignature
                                        file={allData?.selected}
                                        setShowThankYou={setShowThankYou}
                                        setAllData={setAllData}
                                        allData={allData}
                                    />
                                </div>
                            }

                            {!Boolean(allDoc?.length) &&
                            <div className={"u_h-full u_w-full"}>
                                <UNoDataFound
                                    image="/images/file-preview.svg"
                                    message="Select document for preview"
                                />
                            </div>
                            }
                        </div>

                    </div>
                </UCustomScrollBar>
            </div>

            {showThankYou && <CongratulationsModal
                onClose={handle?.closeThankYou}
                onSubmit={handle?.logOut}
                hideCancel={true}
                hideHeader={true}
                isAutoLogout={true}
                submitType={"Logout"}
                cancelType={"close"}
            />}


            {/** SHow Reason*/}
            {allData?.showReason &&
            <UModal
                open={allData?.showReason}
                maxWidth={540}
                onClose={() => handle.closeReasonModal("showReason")}
                header={<h4>Reason of {allData?.status === 2 ? "Accept" : "Decline"} </h4>}
            >
                <div className="u_p-15">
                    <UInput label="Write a Reason" textarea asterisk hasError={false}>
                        <textarea
                            name={'reason'}
                            className={`u_textarea u_resize`}
                            value={allData?.reason}
                            autoComplete="off"
                            maxLength={1000}
                            rows="10"
                            onChange={(e) => handle.reasonModal(e, "reason")}
                        />
                    </UInput>

                    {allData?.status === 2 &&
                        <UInput label={`Expected ${getLabel(PROFILE_SECTION.basicInfo, 'joiningDate', 'Joining Date')}`} asterisk datepicker selectDate={allData?.joiningDate ? new Date(allData?.joiningDate) : null}
                             className={"u_mt-16"} hasError={allData?.status === 2 ? validator.current.message("joiningDate", allData?.joiningDate, 'required') : false}>
                        <UDatePicker
                            dateFormat="dd/MM/yyyy"
                            placeholderText=""
                            minDate={new Date()}
                            onChange={(e) => handle.changeDate(e, "joiningDate")}
                            selected={allData?.joiningDate ? new Date(allData?.joiningDate) : null}
                            popperPlacement="bottom-start"
                        />
                    </UInput>}

                </div>

                <div className="u_modal-buttons">
                    {/*<UButton variant="white" type="Cancel" onClick={() => handle?.closeReasonModal("showReason")}/>*/}
                    <UButton
                        btnType={allData?.status === 2 ? "approve" : "reject"}
                        variant={allData?.status === 2 ? "greenLower" : "redLower"}
                        type={allData?.status === 2 ? "Accept" : "Decline"}
                        onClick={_ => handle?.reasonSubmit(allData?.status === 2 ? 11 : 12)}
                        disabled={ allData?.status === 2 ?  (!allData?.reason?.trim()?.length || !allData?.joiningDate) : (!allData?.reason?.trim()?.length)}/>
                        {/** label: 'Offer Accepted', color: "#60b158", value: 11, step: [5] , label: 'Offer Declined', color: "#FF6961", value: 12, step: [5] , */}
                </div>
            </UModal>
            }

        </React.Fragment>
    );
};

export default OfferAcceptDecline;

